(function () {
  'use strict';

  var SKU_PATTERNS = [
    /^\d{2}-\d{3}$/
  ];

  function normalize(raw) {
    return raw
      .trim()
      .toUpperCase()
      .replace(/^(ISBN|EAN)(-1[03])?:?\s*/, '')
      .replace(/[\s-]/g, '');
  }

  function classify(rawValue) {
    var trimmed = rawValue.trim();
    if (SKU_PATTERNS.some(function (p) { return p.test(trimmed); })) {
      return { field: 'variants.sku', value: trimmed };
    }
    var cleaned = normalize(rawValue);
    if (/^97[89]\d{10}$/.test(cleaned)) return { field: 'variants.barcode', value: cleaned };
    if (/^\d{9}[\dX]$/.test(cleaned)) return { field: 'variants.barcode', value: cleaned };
    if (/^\d{8,14}$/.test(cleaned)) return { field: 'variants.barcode', value: cleaned };
    return null;
  }

  function buildQuery(match) {
    return match.field + ':"' + match.value + '"';
  }

  function enhanceForm(form) {
    if (form.dataset.skuEnhanced === 'true') return;
    form.dataset.skuEnhanced = 'true';
    form.addEventListener('submit', function () {
      var input = form.querySelector('input[name="q"]');
      if (!input) return;
      var match = classify(input.value);
      if (match) input.value = buildQuery(match);
    });
  }

  // NEU: technische Query im Eingabefeld wieder "entschärfen"
  function restoreDisplayValue() {
    var params = new URLSearchParams(window.location.search);
    var q = params.get('q') || '';
    var match = q.match(/^variants\.(sku|barcode):"(.+)"$/);
    if (!match) return;

    var displayValue = match[2];
    document.querySelectorAll('input[name="q"]').forEach(function (input) {
      input.value = displayValue;
    });
  }

  function init() {
    document.querySelectorAll('form[action*="/search"]').forEach(enhanceForm);
    restoreDisplayValue();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();